// Oil Painting
// Ported from flash project - http://wonderfl.net/c/92Ul
//
//
export class OilPainting {
  canvas;
  context;
  width;
  height;
  startPos;
  prevPos;
  color;

  constructor(canvas) {
    this.sinHalf = Math.sin(0.5); // Pre-calculate constant
    this.cosHalf = Math.cos(0.5); // Pre-calculate constant

    this.color = "#" + Math.floor(Math.random() * 16777215).toString(16);
    this.canvas = canvas;
    this.context = canvas.getContext("2d");

    this.width = window.innerWidth;
    this.height = window.innerHeight;

    this.canvas.width = this.width;
    this.canvas.height = this.height;

    this.clearPainting = this.clearPainting.bind(this);
    this.setRandomStrokeColor = this.setRandomStrokeColor.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);

    this.canvas.addEventListener("mousemove", this.onMouseMove, { passive: true });
    this.canvas.addEventListener("touchmove", this.onTouchMove, { passive: true });
    this.canvas.addEventListener("pointerdown", this.onPointerDown, { passive: true });
    this.canvas.addEventListener("dblclick", this.clearPainting, { passive: true });
  }

  drawAt(x, y) {
    if (!this.prevPos) {
      this.prevPos = { x, y };
      this.startPos = { x, y };
      return;
    }

    const ctx = this.context;
    const { x: prevX, y: prevY } = this.prevPos;
    const { x: startX, y: startY } = this.startPos;

    const distance = Math.hypot(prevX - startX, prevY - startY);
    // Prevent division by very small numbers to limit circle size
    const minDistance = Math.max(distance, 2);
    const size = (Math.random() * 15) / minDistance;

    const controlX = (prevX - startX) * this.sinHalf + startX;
    const controlY = (prevY - startY) * this.cosHalf + startY;

    // Calculate offsets for the paint drops effect
    const a = distance * 10 * (Math.pow(Math.random(), 2) - 0.5);
    const r = Math.random() - 0.5;

    // Update positions for next iteration
    this.startPos = { x: prevX, y: prevY };
    this.prevPos = { x, y };

    // Calculate line width with randomness
    const lineWidth = (Math.random() * 2 + 1.5) * size + (Math.random() * 1.5 + 1) * size;

    ctx.lineWidth = lineWidth;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";

    ctx.beginPath();
    ctx.moveTo(startX, startY);
    ctx.quadraticCurveTo(controlX, controlY, x, y);

    ctx.fillStyle = this.color;
    ctx.strokeStyle = this.color;

    // Add small paint drops on the sides
    ctx.moveTo(startX + a, startY + a);
    ctx.lineTo(startX + r + a, startY + r + a);

    ctx.stroke();
    ctx.fill();
  }

  setRandomStrokeColor() {
    this.color = "#" + Math.floor(Math.random() * 16777215).toString(16);
    this.context.fillStyle = this.color;
    this.context.strokeStyle = this.color;
  }

  clearPainting(e) {
    // e.preventDefault();
    this.context.clearRect(0, 0, this.width, this.height);
  }

  onPointerDown(e) {
    if (e.pointerType === "touch") {
      this.prevPos = null;
      this.startPos = null;
    }
    this.setRandomStrokeColor();
  }

  onMouseMove(e) {
    this.drawAt(e.layerX, e.layerY);
  }

  onTouchMove(e) {
    const touch = e.touches[0];
    if (touch) {
      this.drawAt(touch.clientX, touch.clientY);
    }
  }

  dispose() {
    this.canvas.removeEventListener("mousemove", this.onMouseMove);
    this.canvas.removeEventListener("touchmove", this.onTouchMove);
    this.canvas.removeEventListener("pointerdown", this.onPointerDown);
    this.canvas.removeEventListener("dblclick", this.clearPainting);
    this.context = null;
    this.canvas = null;
  }
}
